/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Table, Empty, Upload, message, Popconfirm } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import _ from 'lodash'
// import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../../constants'

import AddForm from './addForm'
import SubscribeProgress from './subscribeProgress'
import ViewImportResult from './importResult'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedHousehold: null,
			isImporting: false,
			importProgress: null,
			isResultShown: false,
			importResults: []
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore, history } = this.props
		const { barangay_uid, user_type, user_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedHousehold, isImporting, 
			importProgress, isResultShown, importResults
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))

		var that = this
		const fileProps = {
			name: 'files',
			multiple: false,
			onChange (info) {
				const { fileList } = info
				const { bulkImport } = that.props
				const files = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
				const params = {
					barangay_uid,
					files 
				}
				bulkImport(params)
					.then((response) => {
						const { bulkImport } = response.data
						if (bulkImport.length > 0) {
							that.setState({ isResultShown: true, importResults: bulkImport })
						}
					})
					.catch(err => {
						console.log('error bulk import', err.message)
						message.error(err.message)
					})
			},
			accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			showUploadList: false,
			beforeUpload (file, fileList) { return false }
		}
		
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row type='flex' justify='center'>
						<a 
							href='/faustinnotech_assets/documents/household-template.xlsx' 
							download
						>Download Household Template</a>
					</Row>
					<Row>
						{
							isAdmin &&
							<Upload {...fileProps}>
								<button 
									disabled={isImporting} 
									type="button" 
									className="btn btn-primary btn-rounded waves-effect waves-light" 
									style={{ float: 'right', marginLeft: 5 }}
								>Bulk Import</button>
							</Upload>
						}
						<button disabled={isImporting} type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
							this.setState({ isAddFormShown: true, isEdit: false, selectedHousehold: null })
						}} style={{ float: 'right' }}>Add New Household</button>
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
					</Row>
					<br />
					<Row>
						<Query 
							query={BARANGAY_HOUSEHOLD} 
							variables={{ searchFilter: filters, barangay_uid }}
							fetchPolicy='network-only'
						>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let households = _.has(data,'allBarangayHousehold') ? data.allBarangayHousehold.data : []
								households = households.map((household, key) => Object.assign({}, household, { key }))
								let _pagination = _.has(data, 'allBarangayHousehold') ? data.allBarangayHousehold.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [
									{
									 	title: 'Household No.',
									 	dataIndex: 'household_no',
									 	key: 'household_no',
									 	width: 120
									}, {
										title: 'Member Count',
										dataIndex: 'member_count',
										key: 'member_count',
										width: 130
									}, {
										title: 'Head of Household',
										key: 'head_first_name',
										width: 200,
										render: (record) => (
											<span style={{ color: 'blue' }}>{record.head_first_name} {record.head_last_name}</span>
										)
									}, {
										title: 'Address',
										key: 'address',
										render: (i) => {
											const address = `${i.house_no || ''} ${i.block || ''} ${i.lot || ''} ${i.street || ''} ${i.address || ''} ${i.purok_name || ''}`
											return (
												<span>{address}</span>
											)
										}
									}, {
										title: 'Action',
										key: 'action',
										width: 200,
										fixed: 'right',
										render: (record) => {
											return (
												<React.Fragment>
													<a style={{ cursor: 'pointer', textDecoration: 'underline', marginRight: 10 }} href="#" onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedHousehold: record })}>Edit</a>
													<a 
														style={{ cursor: 'pointer', textDecoration: 'underline', marginRight: 10 }} 
														href='javascript:void(0)'
														onClick={() => history.push({
															pathname: '/household/manage',
															state: { household: record }
														})}
													>Manage</a>
													{
														isAdmin &&
														<Popconfirm
															title="Are you sure delete this household?"
															onConfirm={() => {
																const { deleteHousehold } = this.props
																deleteHousehold({ household_uid: record.uid })
																	.then((response) => {
																		message.success('Household successfully deleted.')

																		//create audit trail
																		const auditParams = {
																			module_name: 'Household',
																			action: 'Delete',
																			message: `Deleted household ${record.household_no}`
																		}
																		AuthStore.saveAuditTrail(auditParams)
																	}).catch(err => {
																		console.log('error deleting household', err)
																		message.error(err.message.replace('GraphQL error:', ''))
																	})
															}}
															// onCancel={cancel}
															okText="Yes"
															cancelText="No"
														>
															<a href='javascript:void(0)' style={{ cursor: 'pointer', textDecoration: 'underline' }}>Delete</a>
														</Popconfirm>
													}
												</React.Fragment>
											)
										}
									}]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												importProgress={importProgress}
												isImporting={isImporting}
												subscribeToImportProgress={() => {
													subscribeToMore({
														document: IMPORT_PROGRESS,
														variables: { user_uid, process_name: 'bulk-import' },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.importProgress.status, 'importing')) {
																this.setState({ isImporting: true, importProgress: subscriptionData.data.importProgress })
															} else {
																this.setState({ isImporting: false, importProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={households} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 'calc(700px + 50%)', y: 1080 }}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedHousehold={selectedHousehold}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedHousehold: null })}
                        />
					}
					{
						isResultShown &&
						<ViewImportResult 
							visible={isResultShown}
							importResults={importResults}
							onCancel={() => this.setState({ isResultShown: false, importResults: [] })}
						/>
					}
				</Col>
			</Row>
		)
	}
}

const BULK_IMPORT = gql`
    mutation bulkImport($input: JSON) {
		bulkImport(input: $input)
    }
`

const BARANGAY_HOUSEHOLD = gql`
    query allBarangayHousehold($barangay_uid: String, $searchFilter: SearchParams) {
		allBarangayHousehold(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const IMPORT_PROGRESS = gql`
	subscription importProgress($user_uid: String, $process_name: String) {
		importProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const DELETE_HOUSEHOLD = gql`
    mutation deleteHousehold($input: JSON) {
		deleteHousehold(input: $input)
    }
`

const composed = compose(
	withRouter,
	inject('AuthStore'),
	graphql(BULK_IMPORT, {
		props({ mutate }) {
			return {
				bulkImport(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBarangayHousehold']
					})
				}
			}
		}
	}),
	graphql(DELETE_HOUSEHOLD, {
		props({ mutate }) {
			return {
				deleteHousehold(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBarangayHousehold']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
